import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const DefaultBlankState = () => {
  return (
    <Box paddingTop="s96" paddingBottom="s120" gap="s16" alignItems="center">
      <Icon.Large icon="love-hands" />
      <Text.Header2>{i18n.t('enps.answer.title_settings')}</Text.Header2>
    </Box>
  )
}
